import React, { Fragment } from 'react';
import { QtcRenderer } from '@3plearning/question-components-library';
import { Box, Text } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { t } from '@lingui/macro';
import { useLocalisation } from '../../../helpers/i18n/use-localisation';
import css from './qtc-correct-answer.scss';

const QtcCorrectAnswer = () => {
  const { i18n } = useLocalisation();
  const { conquestReducer, mleReducer } = useSelector(state => state);
  const {
    isMarked,
    conquestData,
    conquestValidation,
    conquestQuestionId
  } = conquestReducer;
  const { isCompleted } = mleReducer;

  return (
    <Fragment>
      {
        isCompleted && conquestValidation && !conquestValidation.isCorrect && (
          <Box className={css['correct-answer']} >
            <Text className={css['correct-answer-text']} >
              {i18n._(t`Here's the correct answer`)}
            </Text>
            <Box
              className={css['correct-answer-container']}
              key={`${conquestQuestionId}-correct-answer${isMarked ? '-validated' : ''}`}
            >
              <QtcRenderer
                callback={() => undefined}
                question={conquestData}
                showCorrectAnswer
                validation={conquestValidation}
              />
            </Box>
          </Box>
        )
      }
    </Fragment>
  );
};

export default QtcCorrectAnswer;
